import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { LanguageToggle } from '../components/ui/LanguageToggle';
export function Privacy() {
  const {
    lang
  } = useLanguage();
  const content = lang === 'es' ? <>
        <h1 data-id="element-460" data-mp="36huvum9g1r0k">Política de Privacidad</h1>
        <p className="muted" data-id="element-461" data-mp="36gtgw6pb4kdk">Última actualización: 11 de julio de 2026</p>

        <h2 data-id="element-462" data-mp="3k8q7257f0k7b">1. Quiénes somos</h2>
        <p data-id="element-463" data-mp="3k7y8qmmfo8dc">
          Dermaclinic LA LLC, que opera bajo la marca Lipo Laser Beverly Hills
          ("nosotros", "nuestro" o "nos"), opera este sitio web (el "Sitio").
          Nos comprometemos a proteger la privacidad y la información personal
          que usted comparte con nosotros.
        </p>

        <h2 data-id="element-464" data-mp="3p8vs32j6j8gf">2. Información que recopilamos</h2>
        <p data-id="element-465" data-mp="1ztee0eqhlr74">
          Podemos recopilar información personal que usted proporciona
          directamente, incluyendo:
        </p>
        <ul data-id="element-466" data-mp="1uvczm740ag1z">
          <li data-id="element-467" data-mp="1uvmofrdbeh63">Nombre, número de teléfono y dirección de correo electrónico.</li>
          <li data-id="element-468" data-mp="h2z18j3agwg2">
            Información, preferencias o detalles que envía a través de nuestros
            formularios de contacto, solicitud de consulta o comunicación.
          </li>
          <li data-id="element-469" data-mp="q2cbvf35fr2d">
            Información técnica y de uso, como dirección IP, tipo de navegador,
            dispositivo, páginas visitadas, tiempo de permanencia y fuente de
            tráfico.
          </li>
        </ul>

        <h2 data-id="element-470" data-mp="zrm54y9qbfs2">3. Cómo usamos su información</h2>
        <p data-id="element-471" data-mp="zv055zux7cwc">Podemos utilizar su información para:</p>
        <ul data-id="element-472" data-mp="14qpbqn5cxu25">
          <li data-id="element-473" data-mp="14q73st9c1ree">Responder a sus consultas y coordinar o programar citas.</li>
          <li data-id="element-474" data-mp="18t3sn1pgujqs">
            Proporcionarle información sobre nuestros servicios y atención
            solicitada.
          </li>
          <li data-id="element-475" data-mp="1drwws3iv4yea">
            Enviarle comunicaciones por SMS y correo electrónico, incluyendo
            recordatorios de citas, actualizaciones de cuenta y ofertas
            promocionales, cuando usted haya proporcionado su consentimiento.
          </li>
          <li data-id="element-476" data-mp="motarm8rylc2">
            Mejorar la experiencia del Sitio, nuestros servicios y campañas.
          </li>
          <li data-id="element-477" data-mp="hr05cvfapvcu">
            Cumplir obligaciones legales y prevenir fraude o uso indebido.
          </li>
        </ul>

        <h2 data-id="element-478" data-mp="vqsskgrm5tg2">4. Consentimiento para SMS</h2>
        <p data-id="element-479" data-mp="vnn493qt6vle">
          Al proporcionar su número de teléfono y otorgar su consentimiento a
          través de nuestros formularios del Sitio, usted acepta recibir
          mensajes de texto de Dermaclinic LA LLC relacionados con recordatorios
          de citas, actualizaciones de cuenta y ofertas promocionales. La
          frecuencia de los mensajes puede variar. Pueden aplicarse tarifas de
          mensajes y datos.
        </p>
        <p data-id="element-480" data-mp="1aenmu1l9s5v9">
          El consentimiento para recibir mensajes de texto no es una condición
          para comprar servicios. Puede cancelar los mensajes SMS en cualquier
          momento respondiendo <strong data-id="element-481" data-mp="1jg3uw2om3vwb">STOP</strong>. Para recibir ayuda,
          responda <strong data-id="element-482" data-mp="1jdhh3lb4ok5n">HELP</strong> o escríbanos a{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-483" data-mp="232f80f2ltrc1">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>

        <h2 data-id="element-484" data-mp="27ye0oeuytvi9">5. Cookies y tecnologías de seguimiento</h2>
        <p data-id="element-485" data-mp="1t2674nxo3hqb">
          Nuestro Sitio puede utilizar cookies y tecnologías de seguimiento
          similares para mejorar la experiencia del usuario, analizar tráfico,
          medir el rendimiento de campañas y personalizar publicidad. Puede
          controlar las preferencias de cookies a través de la configuración de
          su navegador. También utilizamos herramientas como Meta Pixel para
          analizar la efectividad de nuestra publicidad.
        </p>

        <h2 data-id="element-486" data-mp="1fbjjbqtg3c90">6. Cómo compartimos información</h2>
        <p data-id="element-487" data-mp="1fcb406li7pki">
          No vendemos su información personal. Podemos compartir información
          limitada con proveedores de servicios que nos ayudan a operar nuestro
          negocio, como plataformas de CRM, comunicaciones, alojamiento,
          análisis y publicidad, o con autoridades cuando la ley lo exija.
        </p>
        <p data-id="element-488" data-mp="yc9on3dpzgzz">
          <strong data-id="element-489" data-mp="tbc6gqspmmyh">
            No vendemos, alquilamos ni compartimos su número de teléfono móvil
            ni la información de consentimiento para SMS con terceros o
            afiliados para fines de marketing. Los datos de consentimiento y
            opt-in del originador de mensajes de texto no se compartirán con
            terceros.
          </strong>
        </p>

        <h2 data-id="element-490" data-mp="fhumx600xa8g">7. Seguridad de datos</h2>
        <p data-id="element-491" data-mp="akbbseymhdkq">
          Implementamos salvaguardas administrativas, técnicas y físicas
          razonables para proteger su información personal contra acceso,
          divulgación, alteración o uso indebido no autorizado. Sin embargo,
          ningún método de transmisión por internet o almacenamiento electrónico
          es completamente seguro.
        </p>

        <h2 data-id="element-492" data-mp="1zxogi5and3md">8. Sus derechos y opciones</h2>
        <p data-id="element-493" data-mp="1v0fyq5tev1ln">Usted puede:</p>
        <ul data-id="element-494" data-mp="1v17jsmpdtgxo">
          <li data-id="element-495" data-mp="1v1h9e96ilm2u">
            Cancelar las comunicaciones SMS en cualquier momento respondiendo
            <strong data-id="element-496" data-mp="23hgaaca0iosj"> STOP</strong>.
          </li>
          <li data-id="element-497" data-mp="27is3ers3hs5h">
            Cancelar comunicaciones por correo electrónico mediante el enlace de
            cancelación incluido en dichos correos.
          </li>
          <li data-id="element-498" data-mp="2cc3bsxck2gzi">
            Solicitar acceso, actualización o eliminación de su información
            personal.
          </li>
          <li data-id="element-499" data-mp="1kj3ysjvmp2ts">Retirar su consentimiento de marketing en cualquier momento.</li>
        </ul>
        <p data-id="element-500" data-mp="1okfu9616oi9w">
          Para ejercer estos derechos, contáctenos directamente usando la
          información de contacto publicada en el Sitio.
        </p>

        <h2 data-id="element-501" data-mp="1thxt23lhlh46">9. Residentes de California</h2>
        <p data-id="element-502" data-mp="1yilu7i3fjec4">
          Los residentes de California pueden tener derechos adicionales bajo
          las leyes de privacidad aplicables, incluyendo el derecho a conocer,
          corregir o solicitar la eliminación de cierta información personal, y
          el derecho a no ser discriminados por ejercer dichos derechos.
        </p>

        <h2 data-id="element-503" data-mp="2k8lkzk8z8jwu">10. Información médica</h2>
        <p data-id="element-504" data-mp="2kbpwz3soojy2">
          El Sitio es informativo y una solicitud de consulta no establece una
          relación médico-paciente. No envíe información médica sensible a menos
          que se lo solicitemos mediante un canal adecuado. La información
          médica protegida, cuando corresponda, se maneja de acuerdo con las
          leyes aplicables.
        </p>

        <h2 data-id="element-505" data-mp="21k6r8p79yrsc">11. Cambios a esta política</h2>
        <p data-id="element-506" data-mp="21gspnj6fqmly">
          Podemos actualizar esta Política de Privacidad ocasionalmente. La
          fecha de "Última actualización" al inicio de esta página indica la
          versión vigente.
        </p>

        <h2 data-id="element-507" data-mp="26i8d1hw3557i">12. Contacto</h2>
        <p data-id="element-508" data-mp="26hylhpve6pzp">
          Si tiene preguntas sobre esta Política de Privacidad, sus datos o las
          comunicaciones de Dermaclinic LA LLC, escríbanos a{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-509" data-mp="1iqb17qsmyd6e">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>
      </> : <>
        <h1 data-id="element-510" data-mp="3pfbo2n2nw8sr">Privacy Policy</h1>
        <p className="muted" data-id="element-511" data-mp="3pf3aesypszgi">Last updated: July 11, 2026</p>

        <h2 data-id="element-512" data-mp="3u8eisyj6doaj">1. Who we are</h2>
        <p data-id="element-513" data-mp="3u9po52s9r43r">
          Dermaclinic LA LLC, doing business as Lipo Laser Beverly Hills ("we,"
          "us," or "our"), operates this website (the "Site"). We are committed
          to protecting your privacy and the personal information you share with
          us.
        </p>

        <h2 data-id="element-514" data-mp="c2jdtqskwse1">2. Information we collect</h2>
        <p data-id="element-515" data-mp="h0uo22msd4ws">
          We may collect personal information you provide directly, including:
        </p>
        <ul data-id="element-516" data-mp="31liry04bv7l">
          <li data-id="element-517" data-mp="31v2x4yhf85d">Your name, phone number, and email address.</li>
          <li data-id="element-518" data-mp="33o78dlmhga7">
            Information, preferences, or details submitted through our contact,
            consultation-request, or communication forms.
          </li>
          <li data-id="element-519" data-mp="2npzijf1xemtv">
            Technical and usage information, such as IP address, browser type,
            device, pages visited, time spent, and traffic source.
          </li>
        </ul>

        <h2 data-id="element-520" data-mp="3jhiep2yh2wf3">3. How we use your information</h2>
        <p data-id="element-521" data-mp="3jecrxudbg6mj">We may use this information to:</p>
        <ul data-id="element-522" data-mp="3egkvcn1q7wc0">
          <li data-id="element-523" data-mp="3eg2sv8oh0lvn">Respond to inquiries and coordinate or schedule appointments.</li>
          <li data-id="element-524" data-mp="3ah2dy19463dx">Provide information about our services and requested care.</li>
          <li data-id="element-525" data-mp="35hhdtni7jozm">
            Send SMS and email communications, including appointment reminders,
            account updates, and promotional offers, when you have provided
            consent.
          </li>
          <li data-id="element-526" data-mp="1zpibz4v4mwo">Improve the Site experience, our services, and our campaigns.</li>
          <li data-id="element-527" data-mp="3tewr8rh9z124">Comply with legal obligations and prevent fraud or misuse.</li>
        </ul>

        <h2 data-id="element-528" data-mp="3ofto5ckuv4ws">4. SMS consent</h2>
        <p data-id="element-529" data-mp="3ogllosy0jcpp">
          By providing your phone number and giving consent through our Site
          forms, you agree to receive text messages from Dermaclinic LA LLC
          related to appointment reminders, account updates, and promotional
          offers. Message frequency may vary. Message and data rates may apply.
        </p>
        <p data-id="element-530" data-mp="sbsvdq5jkran">
          Consent to receive text messages is not a condition of purchasing
          services. You may opt out of SMS messages at any time by replying
          <strong data-id="element-531" data-mp="1285xncf5kdh0"> STOP</strong>. For help, reply <strong data-id="element-532" data-mp="12749c694luhc">HELP</strong> or email{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-533" data-mp="169r4ag13fvir">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>

        <h2 data-id="element-534" data-mp="1b8klaifla4no">5. Cookies and tracking technologies</h2>
        <p data-id="element-535" data-mp="1g7x8j4adhdqs">
          Our Site may use cookies and similar tracking technologies to improve
          user experience, analyze site traffic, measure campaign performance,
          and personalize advertising. You can control cookie preferences
          through your browser settings. We also use tools such as Meta Pixel to
          analyze the effectiveness of our advertising.
        </p>

        <h2 data-id="element-536" data-mp="1yyewywo69n6c">6. How we share information</h2>
        <p data-id="element-537" data-mp="1yzgar8wkonrr">
          We do not sell your personal information. We may share limited
          information with service providers that help us operate our business,
          such as CRM, communications, hosting, analytics, and advertising
          platforms, or with authorities when required by law.
        </p>
        <p data-id="element-538" data-mp="21ewrouyml6go">
          <strong data-id="element-539" data-mp="21e4x9ngrlerz">
            We do not sell, rent, or share your mobile phone number or SMS
            opt-in information with third parties or affiliates for marketing
            purposes. Text messaging originator opt-in data and consent will not
            be shared with any third parties.
          </strong>
        </p>

        <h2 data-id="element-540" data-mp="2k6z4fv85c2ln">7. Data security</h2>
        <p data-id="element-541" data-mp="2k80qeuqpa9i5">
          We implement reasonable administrative, technical, and physical
          safeguards to protect your personal information from unauthorized
          access, disclosure, alteration, or misuse. However, no method of
          internet transmission or electronic storage is completely secure.
        </p>

        <h2 data-id="element-542" data-mp="us17ilxa55pb">8. Your rights and choices</h2>
        <p data-id="element-543" data-mp="382kkpswtig0u">You may:</p>
        <ul data-id="element-544" data-mp="3832mt665vogo">
          <li data-id="element-545" data-mp="383lwy0pkl8k5">
            Opt out of SMS communications at any time by replying
            <strong data-id="element-546" data-mp="33a9jmmqcco6p"> STOP</strong>.
          </li>
          <li data-id="element-547" data-mp="339hm36d6ogds">
            Unsubscribe from email communications through the unsubscribe link
            in those emails.
          </li>
          <li data-id="element-548" data-mp="2ubfhkgu8r5lr">
            Request access to, an update to, or deletion of your personal
            information.
          </li>
          <li data-id="element-549" data-mp="3r0dd419tf7jz">Withdraw marketing consent at any time.</li>
        </ul>
        <p data-id="element-550" data-mp="3mz1w2k50bune">
          To exercise these rights, contact us directly using the contact
          information published on this Site.
        </p>

        <h2 data-id="element-551" data-mp="3i2bflvpaix1g">9. California residents</h2>
        <p data-id="element-552" data-mp="3d1ndoeziwvsg">
          California residents may have additional rights under applicable
          privacy laws, including the right to know, correct, or request
          deletion of certain personal information and the right not to be
          discriminated against for exercising those rights.
        </p>

        <h2 data-id="element-553" data-mp="232w2m2fpe2cb">10. Medical information</h2>
        <p data-id="element-554" data-mp="233xe280msquk">
          This Site is informational, and requesting a consultation does not
          establish a physician-patient relationship. Please do not submit
          sensitive medical information unless we request it through an
          appropriate channel. Protected health information, when applicable, is
          handled in accordance with applicable law.
        </p>

        <h2 data-id="element-555" data-mp="1kbuw8tc974iq">11. Changes to this policy</h2>
        <p data-id="element-556" data-mp="1p3cv9bupuv12">
          We may update this Privacy Policy from time to time. The "Last
          updated" date at the top of this page identifies the current version.
        </p>

        <h2 data-id="element-557" data-mp="1b9vc3s5xzkbk">12. Contact</h2>
        <p data-id="element-558" data-mp="1fdjn6kts8y1k">
          If you have questions about this Privacy Policy, your data, or
          Dermaclinic LA LLC communications, please email{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-559" data-mp="11f3hmx7npdl0">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>
      </>;
  return <LegalLayout data-id="element-560" data-mp="mqtpjbanhrje">{content}</LegalLayout>;
}
function LegalLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <main className="min-h-screen bg-brand-cream" data-id="element-561" data-mp="ht1vobqg3vck">
      <header className="border-b border-brand-stone/50 py-6" data-id="element-562" data-mp="hucxw748sv1k">
        <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-563" data-mp="wq123w9k9i5g">
          <Link to="/" className="flex items-baseline gap-1.5" data-id="element-564" data-mp="rp4vvc1qljwv">
            <span className="text-2xl font-serif font-normal text-brand-dark" data-id="element-565" data-mp="15pxpzvo4mczg">
              Lipo Laser
            </span>
            <span className="text-[10px] font-medium tracking-[0.2em] uppercase text-brand-gold" data-id="element-566" data-mp="10rmk1w0ycmmi">
              Beverly Hills
            </span>
          </Link>
          <LanguageToggle data-id="element-567" data-mp="1fhldjlhkb9vn" />
        </div>
      </header>

      <article className="container mx-auto px-6 py-20 max-w-3xl legal-content" data-id="element-568" data-mp="1ahz29hlao3ph">
        {children}
        <div className="mt-16 pt-8 border-t border-brand-stone/50" data-id="element-569" data-mp="1oh8j8jhbr1ui">
          <Link to="/" className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/60 hover:text-brand-dark transition-colors" data-id="element-570" data-mp="1kfdgdajqwgem">
            ← Home
          </Link>
        </div>
      </article>

      <style data-id="element-571" data-mp="3iut2gu9nqp7c">{`
        .legal-content h1 {
          font-family: 'Playfair Display', serif;
          font-weight: 300;
          font-size: 3rem;
          color: #1B1714;
          letter-spacing: -0.02em;
          margin-bottom: 0.5rem;
        }
        .legal-content h2 {
          font-family: 'Playfair Display', serif;
          font-weight: 400;
          font-size: 1.5rem;
          color: #1B1714;
          margin-top: 2.5rem;
          margin-bottom: 0.75rem;
        }
        .legal-content p, .legal-content li {
          color: rgba(27, 23, 20, 0.75);
          line-height: 1.7;
          font-weight: 300;
          margin-bottom: 0.75rem;
        }
        .legal-content ul {
          list-style: none;
          padding-left: 1rem;
        }
        .legal-content li {
          padding-left: 1.5rem;
          position: relative;
        }
        .legal-content li::before {
          content: '·';
          color: #C9A961;
          position: absolute;
          left: 0;
          font-weight: 700;
        }
        .legal-content a {
          color: #C97B63;
          text-decoration: underline;
          text-underline-offset: 3px;
        }
        .legal-content a:hover {
          color: #1B1714;
        }
        .legal-content .muted {
          color: rgba(27, 23, 20, 0.4);
          font-size: 0.875rem;
          font-weight: 500;
          letter-spacing: 0.05em;
          margin-bottom: 3rem;
        }
        .legal-content strong {
          color: #1B1714;
          font-weight: 500;
        }
      `}</style>
    </main>;
}